export default "__VITE_ASSET__BKJmaYnm__"